import { AppFunctionComponent } from "../../types"
import React from "react"
import styled from "styled-components"
import ListSection from "../../components/common/sections/list/list.component"
import {
  AccordionListItemBuilder,
  ListBuilder,
  ListItemBuilder,
  ListItemLayout,
  ListItemType,
  ListLayout,
  ListItem as ContentfulListItem,
  AccordionItem as ContentfulAccordionItem,
  NewsItem as ContentfulNewsItem,
  CareerOffer as ContentfulCareerOffer,
} from "../../types"
import ListItem from "../../components/common/sections/list/list-item.component"
import AccordionItem from "../../ui/components/accordion/accordion-item.component"
import { kebabCase } from "lodash"
import { interactiveAccordion } from "../../ui/helpers/interactive-accordion/interactive-accordion-item.hook"
import { useLocation } from "react-use"
import NewsItem from "../../ui/components/news-item/news-item.component"
import RichText from "../rich-text/rich-text.resolver"
import CareerOffers from "../../components/career/career-offers.component"
import QuickStartRevealList from "../../components/common/sections/custom/quick-start/quick-start-reveal-list.component"
import ShowOnlyOn from "../../components/common/show-only-on.component"

export const Item = styled((props) => <ListItem {...props} />)``

const ListResolver: AppFunctionComponent<ListBuilder> = ({
  listLayout,
  listSize,
  listItemLayout,
  text,
  items,
  style,
  showOnlyOn,
  anchorId,
}) => {
  const location = useLocation()

  const resolveListItemLayout = (index: number) => {
    if (
      listLayout === ListLayout.TwoColumnsLastWide &&
      index === items.length - 1
    ) {
      return ListItemLayout.Wide
    }
    return listItemLayout
  }

  const resolveItems = (
    items:
      | ContentfulListItem[]
      | ContentfulAccordionItem[]
      | ContentfulNewsItem[]
      | ContentfulCareerOffer[]
  ) => {
    if (!items?.length) {
      return null
    }
    const type = items[0].internal.type

    switch (type) {
      case ListItemType.Item:
        return (items as ListItemBuilder[]).map((item, index) => {
          return (
            <Item
              key={item.id}
              imageWidth={style?.item_image_width}
              background={style?.item_background}
              layout={resolveListItemLayout(index)}
              {...item}
            />
          )
        })

      case ListItemType.AccordionItem:
        return (items as AccordionListItemBuilder[]).map((item) => {
          const text = item.accordionText ? (
            <RichText content={item.accordionText} />
          ) : null
          const slug = kebabCase(item.title)

          const props = {
            title: item.title,
            link: location.pathname || "",
            text,
            slug,
          }
          return (
            <AccordionItem
              key={slug}
              {...props}
              {...interactiveAccordion(props)}
            />
          )
        })

      case ListItemType.NewsItem:
        return (items as ContentfulNewsItem[]).map((item) => {
          return <NewsItem {...item} key={item.id} />
        })
      case ListItemType.CareerOffer:
        return (items as ContentfulCareerOffer[]).map((item) => {
          return <CareerOffers {...item} key={item.id} />
        })
      default:
        return <></>
    }
  }

  if (listItemLayout === ListItemLayout.RevealSection) {
    return (
      <ShowOnlyOn showOnlyOn={showOnlyOn}>
        <QuickStartRevealList
          text={text}
          style={style}
          revealList={items as unknown as ListBuilder[]}
          anchorId={anchorId}
        />
      </ShowOnlyOn>
    )
  }
  return (
    <ListSection
      listLayout={listLayout}
      listSize={listSize}
      listItemLayout={listItemLayout}
      text={text}
      items={items}
      style={style}
      anchorId={anchorId}
    >
      {resolveItems(items)}
    </ListSection>
  )
}

export default ListResolver
